import { Configuration, LogLevel } from '@azure/msal-browser';

export interface MsalConfig {
    clientId: string;
    authority: string;
    redirectUri: string;
    scopes: string[];
}

export const createMsalConfig = (config: MsalConfig): Configuration => ({
    auth: {
        clientId: config.clientId,
        authority: config.authority,
        redirectUri: config.redirectUri,
        postLogoutRedirectUri: config.redirectUri,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
            logLevel: LogLevel.Warning,
        },
    },
});

export const loginRequest = (scopes: string[]) => ({
    scopes,
});